module.exports = __webpack_public_path__ + "img/9788985635882.2f285396.jpg";